import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import Topbar from 'src/components/topbar';
import Footer from 'src/components/footer';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { extractPrintableSection, buildPrintHead } from 'src/utils/print.utils';
import {
  setPrintHtmlPart as setPrintHtmlPartAction,
  setPrintHtmlHead as setPrintHtmlHeadAction,
  clearPrintHtml as clearPrintHtmlAction
} from 'src/store/actions';

import useStyles from './styles';

function DashboardLayout({ children }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(clearPrintHtmlAction());
    if (location.pathname === '/') {
      // import useLocation from react-router-dom
      const el = document.getElementById('landing-page-root');
      if (el) {
        const html = extractPrintableSection(el);
        dispatch(setPrintHtmlPartAction('home', html));
      }
      dispatch(setPrintHtmlHeadAction(buildPrintHead()));
    }
  }, [dispatch, location.pathname]);

  return (
    <Container
      id="landing-page-root"
      className={classes.container}
      disableGutters
    >
      <Topbar />
      <div className={classes.content}>{children}</div>
      <Footer hasBackButton={false} hasMargin />
    </Container>
  );
}

DashboardLayout.propTypes = { children: PropTypes.node.isRequired };

export default DashboardLayout;
